import { c as _c } from "react/compiler-runtime";
import { Box, IconButton, Typography } from '@mui/material';
import type { MobileFilterCloseReason } from '../../types';
import { DIALOG_TITLE_ID, TITLE } from '../constants';
import { ClearAllButton } from './ClearAllButton';
export function Header(t0) {
  const $ = _c(10);
  const {
    closeDialog
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Typography id={DIALOG_TITLE_ID} variant="text" sx={{
      fontWeight: 500,
      color: "text.secondary",
      textTransform: "uppercase"
    }}>{TITLE}</Typography>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      display: "flex",
      gap: "1.5rem",
      alignItems: "center"
    };
    t4 = <ClearAllButton />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      p: 0
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== closeDialog) {
    t6 = () => closeDialog({
      reason: "close"
    });
    $[5] = closeDialog;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span aria-hidden="true" className="mask-icon mask-icon-close" style={{
      width: 24,
      height: 24
    }} />;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t6) {
    t8 = <Box sx={t1}>{t2}<Box sx={t3}>{t4}<IconButton sx={t5} onClick={t6} aria-label="Close filters dialog">{t7}</IconButton></Box></Box>;
    $[8] = t6;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  return t8;
}